import Flickity from "flickity";

const nss_marquee = {
    init: () => {
        const nssMarqueeEls = document.querySelectorAll('[nss-marquee]');

        function initMarquee(marqueeSection) {
            const sliderEl = marqueeSection.querySelector('[nss-marquee-carousel]');
            const direction = sliderEl?.getAttribute('nss-marquee-carousel-dir') || '';
            const sliderOptions = {
                prevNextButtons:false,
                pageDots: false,
                wrapAround: true,
                resize: true,
                freeScroll: true,
            };
            let sliderFlickity;
            let requestId = undefined;

            function playMarquee() {
                if (direction == 'ltr') {
                    sliderFlickity.x += 0.8;
                } else {
                    sliderFlickity.x -= 0.8;
                }
                sliderFlickity.settle(sliderFlickity.x);
                requestId = window.requestAnimationFrame(playMarquee);
            }
            function pauseMarquee() {
                if (requestId) {
                    window.cancelAnimationFrame(requestId);
                    requestId = undefined;
                }
            }

            function initCarousel() {
                sliderFlickity = new Flickity(sliderEl, sliderOptions);
                requestId = undefined;
                sliderFlickity.x = 0;
                playMarquee();
                sliderEl.addEventListener('mouseenter', pauseMarquee);
                sliderEl.addEventListener('mouseleave', playMarquee);

                window.addEventListener('load', () => {
                    setTimeout(() => {
                        sliderFlickity.resize();
                    }, 250);
                });
            }

            function destroyCarousel() {
                sliderEl.removeEventListener('mouseleave', playMarquee);
                sliderEl.removeEventListener('mouseenter', pauseMarquee);
                pauseMarquee();
                sliderFlickity.cells.forEach(cell => cell.element.style.height = '');
                sliderFlickity.destroy();
            }

            function checkWidth() {
                if (sliderFlickity?.isActive) {
                    if (sliderEl.clientWidth > sliderFlickity.slideableWidth) {
                        destroyCarousel();
                    }
                } else if (sliderEl.scrollWidth > sliderEl.clientWidth) {
                    initCarousel();
                }
            }
            checkWidth();

            window.addEventListener('resize', () => {
                setTimeout(() => {
                    checkWidth();
                }, 150);
            });
        }

        [...nssMarqueeEls].forEach(nssMarqueeEl => {
            initMarquee(nssMarqueeEl);
        });
    
        /**
         * Theme Editor Events
         */
        document.addEventListener(`shopify:section:load`, e => {
            const sectionId         = e.detail.sectionId,
                  marqueeSectionEl = e.target.querySelector(`[data-section-id="${sectionId}"][nss-marquee]`),
                  marqueeCarouselEl  = marqueeSectionEl.querySelector(`[nss-marquee-carousel]`),
                  marqueeEl        = Flickity.data(marqueeCarouselEl);

            if (marqueeSectionEl) {
                marqueeEl?.destroy();
                initMarquee(marqueeSectionEl);
            }
        });
    }
}

export default nss_marquee;
